// extracted by mini-css-extract-plugin
export var bannerLogo = "overlay-module--banner-logo--80b1e";
export var lineAnim = "overlay-module--lineAnim--ef12a";
export var loaderLine = "overlay-module--loader-line--aea52";
export var overlay = "overlay-module--overlay--33141";